import React from 'react'

import ServicePill from '@/components/flows/CompleteRegistrationFlow/steps/1_CompanyServices/components/nonFcaServices/ServicePill'
import { useDeleteServiceMutation } from '@/components/flows/CompleteRegistrationFlow/steps/1_CompanyServices/hooks/useDeleteServiceMutation'
import { useInvalidateCurrentCompanyServicesQuery } from '@/hooks/useCompanyServicesQuery'
import { CompanyServiceCollectionItem } from '@/types/responses/companies'

interface Props {
  service: CompanyServiceCollectionItem
}

const SelectedServicePill: React.FC<Props> = ({ service }) => {
  const invalidateCompanyServicesQuery =
    useInvalidateCurrentCompanyServicesQuery()

  const deleteServiceMutation = useDeleteServiceMutation({
    onSuccess: () => invalidateCompanyServicesQuery(),
  })

  return (
    <ServicePill
      serviceName={service.serviceArea.name}
      onDelete={() => deleteServiceMutation.mutate(service.id)}
      isDeleting={deleteServiceMutation.isPending}
    />
  )
}

export default SelectedServicePill
